import { normalizePathname } from '@zapier/url-utils';

// Indicates whether the given `href` should be considered selected
// based on the value of `selectedHref`. The rules of this are somewhat
// specific to `UniversalSidebar`, so be careful if you try to make
// this more generic!
export const isLinkSelected = (linkHref: string, currentPageHref: string) => {
  // if its a path
  if (currentPageHref.startsWith('/')) {
    return normalizePathname(linkHref).endsWith(
      normalizePathname(currentPageHref)
    );
  }

  let parsedSelectedHref;

  try {
    parsedSelectedHref = new URL(currentPageHref);
  } catch {
    return normalizePathname(linkHref).endsWith(
      normalizePathname(currentPageHref)
    );
  }

  const hostname = parsedSelectedHref.hostname;

  // if the url starts with zapier.com or zapier-staging.com
  if (hostname === 'zapier.com' || hostname === 'zapier-staging.com') {
    // trim first part of the  url
    return normalizePathname(linkHref).endsWith(
      normalizePathname(parsedSelectedHref.pathname)
    );
  }

  // if it's a subdomain
  if (hostname.split('.').length > 2) {
    return linkHref.includes(hostname);
  }

  return normalizePathname(linkHref).endsWith(
    normalizePathname(currentPageHref)
  );
};
